import { toLowerCase } from '../helpers/utils';

export class CountrySearchService {
    static search(countries, value) {
        const term = value;
        const termLength = term.length;
        return countries?.filter((country) => {
            const byName = term === undefined || toLowerCase(country.name).indexOf(toLowerCase(term)) >= 0;
            const bySynonym = toLowerCase(country.synonym).indexOf(toLowerCase(term)) >= 0;
            const byAlias = toLowerCase(country.alias).indexOf(toLowerCase(term)) >= 0;
            const byCurrencyCode =
                Array.isArray(country.currencies) &&
                country.currencies.find((currency) => {
                    return toLowerCase(currency.code).indexOf(toLowerCase(term)) >= 0;
                });
            const byPrefix = (country.phonePrefix ?? country.prefix ?? country.phone_prefix)?.indexOf('' + term) >= 0;
            const byLongTerms = byName || bySynonym || byCurrencyCode || byPrefix || byAlias;
            const byShotTerms = byName || byCurrencyCode || byPrefix || byAlias;
            return termLength === 1 ? byShotTerms : byLongTerms;
        });
    }
}

export class RecentCountriesService {
    static getCountriesArrays(countries) {
        const favoriteCountries = countries?.filter((c) => c.favorite);
        const suggestionsCountries = countries?.filter((c) => c.popularRank && c.popularRank !== 0);
        return {
            favoriteCountries,
            suggestionsCountries,
        };
    }

    static compareByUsageCount(a, b) {
        if (a.usageCount > b.usageCount) {
            return -1;
        } else if (a.usageCount < b.usageCount) {
            return 1;
        } else if (a.usageCount === b.usageCount) {
            const nameA = a.name.toLowerCase(),
                nameB = b.name.toLowerCase();
            if (nameA < nameB) {
                return -1;
            } else if (nameA > nameB) {
                return 1;
            }
            return 0;
        }
        return 0;
    }

    static compareByPopularRank(a, b) {
        return a.popularRank - b.popularRank;
    }
}
